import { apiSlice } from "../../../Redux/Api/ApiSlice";
import moment from "moment";
export const PayrollSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //AllowanceNameGetAPI
    Allowance: builder.query({
      query: () => {
        return {
          url: "users/allowances-name/priority/true",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "allowances-name", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "allowances-name",
                id: uid,
              })),
              { type: "allowances-name", id: "LIST" },
            ]
          : [{ type: "allowances-name", id: "LIST" }],
    }),

    //AllowanceNameMutationAPI
    AllowanceOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "allowances-name", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //AllowanceStructureGetAPI
    AllowanceStructure: builder.query({
      query: () => {
        return {
          url: "users/allowances-structure",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "allowances-structure", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "allowances-structure",
                id: uid,
              })),
              { type: "allowances-structure", id: "LIST" },
            ]
          : [{ type: "allowances-structure", id: "LIST" }],
    }),

    //AllowanceStructureMutationAPI
    AllowanceStructureOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "allowances-structure", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //DeductionNameGetAPI
    Deduction: builder.query({
      query: () => {
        return {
          url: "users/deduction-name/priority/true",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "deduction-name", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "deduction-name",
                id: uid,
              })),
              { type: "deduction-name", id: "LIST" },
            ]
          : [{ type: "deduction-name", id: "LIST" }],
    }),

    //DeductionNameMutationAPI
    DeductionOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "deduction-name", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //DeductionStructureGetAPI
    DeductionsStructure: builder.query({
      query: () => {
        return {
          url: "users/deduction-structure",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "deduction-structure", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "deduction-structure",
                id: uid,
              })),
              { type: "deduction-structure", id: "LIST" },
            ]
          : [{ type: "deduction-structure", id: "LIST" }],
    }),
    //DeductionStructureMutationAPI
    DeductionsStructureOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "deduction-structure", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //RemittancesNameGetAPI
    Remittances: builder.query({
      query: () => {
        return {
          url: "users/remittance-name/priority/true",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "remittance-name", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "remittance-name",
                id: uid,
              })),
              { type: "remittance-name", id: "LIST" },
            ]
          : [{ type: "remittance-name", id: "LIST" }],
    }),
    AdminFeeInstallmentGet: builder.query({
      query: (url) => {
        return {
          url: `users/installments${url ? url : ""}`,
        };
      },
      transformResponse: (response, meta, arg) =>
        response?.data?.map((item) => ({
          ...item,
          classes: item?.classes?.map((cls) => ({ key: cls, value: cls })),
          classNames: item?.classes,
          lastDateOfInstallment: moment(
            item?.lastDateOfInstallment,
            "DD-MM-YYYY"
          ).format("YYYY-MM-DD"),
        })),
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "Admin-Fee-Installment", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "Admin-Fee-Installment",
                id: uid,
              })),
              { type: "Admin-Fee-Installment", id: "LIST" },
            ]
          : [{ type: "Admin-Fee-Installment", id: "LIST" }],
    }),
    //RemittancesNameMutationAPI
    RemittancesOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "remittance-name", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //RemittancesStructureGetAPI
    RemittanceStructure: builder.query({
      query: () => {
        return {
          url: "users/remittance-structure",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "remittance-structure", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "remittance-structure",
                id: uid,
              })),
              { type: "remittance-structure", id: "LIST" },
            ]
          : [{ type: "remittance-structure", id: "LIST" }],
    }),

    //RemittancesStructureOperationAPI
    RemittanceStructureOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "remittance-structure", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //PayScaleGetAPI
    PayScale: builder.query({
      query: () => {
        return {
          url: "users/payScale",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "payScale", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "payScale",
                id: uid,
              })),
              { type: "payScale", id: "LIST" },
            ]
          : [{ type: "payScale", id: "LIST" }],
    }),

    //PayScaleMutationAPI
    PayScaleOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error ? [{ type: "payScale", id: arg.uid ? arg.uid : "LIST" }] : null,
    }),

    //IncrementCycleGetAPI
    GetIncrementCycle: builder.query({
      query: () => {
        return {
          url: "users/increment-cycle",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "increment-cycle", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "increment-cycle",
                id: uid,
              })),
              { type: "increment-cycle", id: "LIST" },
            ]
          : [{ type: "increment-cycle", id: "LIST" }],
    }),

    //IncrementCycleMutationAPI
    IncrementCycleOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "increment-cycle", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //designationGetAPI
    DesignationStructure: builder.query({
      query: () => {
        return {
          url: "users/payroll-designation/priority/true",
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "designation", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "designation",
                id: uid,
              })),
              { type: "designation", id: "LIST" },
            ]
          : [{ type: "designation", id: "LIST" }],
    }),

    //designationMutationAPI
    DesignationStructureOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "designation", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //GetEmployeeInfo
    EmployeeInfo: builder.query({
      query: (props) => {
        return {
          url: `users/employee-info${
            props?.uid ? "/" + props?.uid : props?.url ? props?.url : ""
          }`,
        };
      },
      transformResponse: (response, meta, arg) =>
        arg?.uid ? response : response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "employee-info", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "employee-info",
                id: uid,
              })),
              { type: "employee-info", id: "LIST" },
            ]
          : [{ type: "employee-info", id: "LIST" }],
    }),
    EmployeeExcelImport: builder.query({
      query: () => {
        return {
          url: `users/payroll-excel-details`,
        };
      },
      transformResponse: (res) => res?.data,
    }),
    //GetEmployeeInfo
    EmployeeInfoFilter: builder.query({
      query: (props) => {
        return {
          url: `users/employee-info-filter${props?.url ? `${props?.url}` : ""}`,
        };
      },
      transformResponse: (response) => response?.data,
    }),

    //EmployeeInfoMutation
    EmployeeInfoOperation: builder.mutation({
      query: ({ body, url, method, noDisplay }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },
      invalidatesTags: (result, error, arg) =>
        !error
          ? [
              { type: "employee-info", id: arg.uid ? arg.uid : "LIST" },
              { type: "users-teacher", id: "LIST" },
              { type: "user-limit", id: "LIMIT" },
            ]
          : null,
    }),

    //ForFilterEmployeeToModifyDetails
    EmployeeFilter: builder.query({
      query: ({ url }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),

    ExcelImport: builder.query({
      query: () => {
        return {
          url: `users/payroll-excel-filds`,
        };
      },
    }),
    //formodifyDetailinBulkEmployee
    fwmExcelImport: builder.mutation({
      query: ({ body, url }) => {
        return {
          url,
          method: "POST",
          body,
        };
      },
    }),
    EmployeeModify: builder.mutation({
      query: (body) => {
        return {
          url: "users/employee-info-modification",
          method: "PUT",
          body: body,
          msz: true,
        };
      },

      invalidatesTags: ["employee-info"],
    }),

    //getlistOfEmployeeForSalaryGeneration
    GetAllEmployeeForSalary: builder.query({
      query: ({ url }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "salary-generation", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "salary-generation",
                id: uid,
              })),
              { type: "salary-generation", id: "LIST" },
            ]
          : [{ type: "salary-generation", id: "LIST" }],
    }),

    GetLeaveEncashment: builder.query({
      query: () => {
        return {
          url: `users/leave-encashment`,
        };
      },
      providesTags: ["leave-encashment"],
    }),

    LeaveEncashmentEmployeeInfoOperation: builder.mutation({
      query: (body) => {
        return {
          url: "users/leave-encashment/employee-info",
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ["employee-info"],
    }),

    LeaveEncashmentOperation: builder.mutation({
      query: ({ body, method, monthValue }) => {
        console.log("monthvvv", body, method, monthValue);

        return {
          url: `users/leave-encashment${
            monthValue ? `?salaryMonthUid=${monthValue}` : ""
          }`,
          method,
          body,
          msz: true,
        };
      },
      invalidatesTags: ["leave-encashment"],
    }),

    LeaveEncashmentDeleteOperation: builder.mutation({
      query: ({ uid, msz }) => {
        return {
          url: `users/leave-encashment/${uid || ""}`,
          method: "DELETE",
          msz: true,
        };
      },
      invalidatesTags: ["leave-encashment"],
    }),

    //SalaryCalculateANDSalaryGeneration
    SalaryGenerationOperation: builder.mutation({
      query: ({ body, url, method, msz }) => {
        return {
          url: `users${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: msz,
        };
      },

      invalidatesTags: (result, error, arg) =>
        !error
          ? [{ type: "salary-generation", id: arg.uid ? arg.uid : "LIST" }]
          : null,
    }),

    //GetAllGeneratedSalary
    GetGeneratedSalary: builder.query({
      query: ({ url }) => {
        return {
          url: `users/salary-generation${url ? url : ""}`,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "salary-generation", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "salary-generation",
                id: uid,
              })),
              { type: "salary-generation", id: "LIST" },
            ]
          : [{ type: "salary-generation", id: "LIST" }],
    }),
    // Based on designation get the allowances/ deduction and remittances.
    GetDesignationADR: builder.mutation({
      query: ({ method, uid, date, noDisplay, salaryGenerationType }) => {
        let query = "";
        if (salaryGenerationType)
          query += `salaryGenerationType=${salaryGenerationType}`;
        if (date) query += `${query ? "&" : ""}appliedFromUid=${date}`;

        return {
          url: `users/employee-payroll-values/${uid}${
            query ? `?${query}` : ""
          }`,
          method: method,
          msz: noDisplay ? false : true,
        };
      },
    }),

    // get all fields which are editable in field wise modification
    GetFieldWiseList: builder.query({
      query: () => {
        return {
          url: "users/employee-info-modification/list",
        };
      },
    }),

    //Reports(employee details view )
    GetEmployeeDetails: builder.query({
      query: ({ url }) => {
        return {
          url: `users/employee-detail-report${url}`,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),

    //Reports (Salary slip)
    GetSalarySlip: builder.query({
      query: ({ url }) => {
        return {
          url: `users/salary-slip-report${url}`,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),

    //Reports (Salary bill)
    GetSalaryBill: builder.query({
      query: ({ url }) => {
        return {
          url: `users/salary-bill-report${url}`,
        };
      },
      // transformResponse: (response, meta, arg) => response?.data,
    }),

    SalaryBillPOST: builder.mutation({
      query: ({ url, body }) => {
        return {
          url: `users/salary-bill?salaryMonthUid=${url}`,
          method: "POST",
          body: body,
        };
      },
      // transformResponse: (response, meta, arg) => response?.data,
      providesTags: (result, error, arg) =>
        arg
          ? [{ type: "salary-bill-report", id: arg }]
          : result
          ? [
              ...result.map(({ uid }) => ({
                type: "salary-bill-report",
                id: uid,
              })),
              { type: "salary-bill-report", id: "LIST" },
            ]
          : [{ type: "salary-bill-report", id: "LIST" }],
    }),

    //salary slip Post get Api
    SalarySlipPOST: builder.mutation({
      query: ({ url, body }) => {
        return {
          url: `users/salary-slip-report?salaryMonthUid=${url}`,
          method: "POST",
          body: body,
        };
      },
    }),

    //IPR Post get Api
    IPRPOST: builder.mutation({
      query: (body) => {
        return {
          url: `users/ipr-sheet`,
          method: "POST",
          body: body ?? {},
        };
      },
    }),

    //LWP Post get Api
    LWPPOST: builder.mutation({
      query: (body) => {
        return {
          url: `users/lwp-detail-report`,
          method: "POST",
          body: body ?? {},
        };
      },
    }),

    //Joining details Post get Api
    JoiningDetailsPOST: builder.mutation({
      query: (body) => {
        return {
          url: `users/joining-info-detail-report`,
          method: "POST",
          body: body ?? {},
        };
      },
    }),

    //Left details Post get Api
    LeftDetailsPOST: builder.mutation({
      query: (body) => {
        return {
          url: `users/left-detail-report`,
          method: "POST",
          body: body ?? {},
        };
      },
    }),

    //PFContribution Post get Api
    PFContributionPOST: builder.mutation({
      query: ({ url, body }) => {
        return {
          url: `users/pf-contribution-report?salaryMonthUid=${url}`,
          method: "POST",
          body: body,
        };
      },
    }),
    PFAbstractGet: builder.query({
      query: ({ url }) => {
        return {
          url: `users/pf-abstract-report${url ? url : ""}`,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),
    PFSubscribePOST: builder.mutation({
      query: ({ url, body }) => {
        return {
          url: `users/pf-subscribers-list?salaryMonthUid=${url}`,
          method: "POST",
          body: body,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),
    GPLEPReport: builder.mutation({
      query: ({ url, body }) => {
        return {
          url: `users/gp-le-report?salaryMonthUid=${url}`,
          method: "POST",
          body: body,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),
    GetBankReport: builder.query({
      query: ({ url }) => {
        return {
          url: `users/bank-report${url}`,
        };
      },
    }),
    ArrearBankReport: builder.query({
      query: ({ url }) => {
        return {
          url: `users/salary-arrear-bank-report${url}`,
        };
      },
      transformResponse: (response, meta, arg) => response,
    }),

    //Reports(salary certificate)
    GetSalaryCertificate: builder.mutation({
      query: ({ url, body }) => {
        return {
          url: `users/salary-certificate${url}`,
          method: "post",
          body,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),
    GetSalaryCertificateUser: builder.query({
      query: (filter) => {
        const queryParams = [];
        if (filter.fromSalaryMonth)
          queryParams.push(`fromSalaryMonthUid=${filter.fromSalaryMonth}`);
        if (filter.toSalaryMonth)
          queryParams.push(`toSalaryMonthUid=${filter.toSalaryMonth}`);
        const queryString = queryParams.length
          ? `?${queryParams.join("&")}`
          : "";
        return {
          url: `users/user-salary-certificate${queryString}`,
          method: "GET",
        };
      },
      transformResponse: (response) => response?.data,
    }),
    GetPFDetailsUser: builder.query({
      query: (filter) => {
        const queryParams = [];
        if (filter.fromSalaryMonth)
          queryParams.push(`salaryMontUid=${filter.fromSalaryMonth}`);

        const queryString = queryParams.length
          ? `?${queryParams.join("&")}`
          : "";
        return {
          url: `users/user-pf-contribution${queryString}`,
          method: "GET",
        };
      },
      transformResponse: (response) => response?.data,
    }),

    //Reports (Salary bill)
    GetDepartmentWiseSalary: builder.query({
      query: ({ url }) => {
        return {
          url: `users/department-wise-salary-response${url}`,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),

    GetPayrollStaticData: builder.query({
      query: ({ url }) => {
        return {
          url: `users/payroll-static-data${url ? url : ""}`,
        };
      },
    }),
    GetContractingCompany: builder.query({
      query: () => {
        return {
          url: `users/contractual-company-name`,
        };
      },
    }),
    MutateContractingCompany: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/contractual-company-name${url ? `/${url}` : ""}`,
          method: method,
          body: body,
        };
      },
    }),
    EmployeePayrollSetValues: builder.mutation({
      query: ({ uid, method, body }) => {
        return {
          url: `users/employee-payroll-set-values${uid ? `/${uid}` : ""}`,
          method: method,
          body: body,
          msz: false,
        };
      },
    }),

    // Hourly Paid
    GetHourlyPaidEmployee: builder.query({
      query: ({ url }) => {
        return {
          url: `users/employee-hourly-salary${url ? `${url}` : ""}`,
        };
      },
    }),
    MutateHourlyPaidEmployee: builder.mutation({
      query: ({ url, method, body, noDisplay }) => {
        return {
          url: `users/employee-hourly-salary${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: noDisplay ? false : true,
        };
      },
    }),

    // Salary Months
    GetSalaryMonths: builder.query({
      query: () => {
        return {
          url: `users/salary-months`,
        };
      },
    }),
    GetSalaryGeneratedMonths: builder.query({
      query: () => {
        return {
          url: `users/salary-months-list?salaryGenerated=true`,
        };
      },
    }),
    GetSalaryDueMonths: builder.query({
      query: () => {
        return {
          url: `users/salary-months-list?salaryGenerated=false`,
        };
      },
    }),
    MutateSalaryMonths: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/salary-months${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: true,
        };
      },
    }),
    GetSalaryMonthsList: builder.query({
      query: () => {
        return {
          url: `users/salary-months-list`,
        };
      },
    }),

    // Projected Salary
    GetProjectedSalary: builder.query({
      query: ({ url }) => {
        return {
          url: `users/employee-projected-salary${url ? `/${url}` : ""}`,
        };
      },
    }),
    MutateProjectedSalary: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/employee-projected-salary${url ? `/${url}` : ""}`,
          method: method,
          body: body,
          msz: true,
        };
      },
    }),
    GetProjectedSalaryFilter: builder.query({
      query: ({ url }) => {
        return {
          url: `users/employee-projected-salary-filter${url ? `${url}` : ""}`,
        };
      },
    }),

    //Recalculate Salary
    MutateRecalculateSalary: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/employee-payroll-recalculate-values${
            url ? `/${url}` : ""
          }`,
          method: method,
          body: body,
          msz: true,
        };
      },
    }),

    //Increament
    GetSalaryIncrementTypes: builder.query({
      query: () => {
        return {
          url: `users/employee-salary-increment-type`,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),

    CalculatIncrement: builder.mutation({
      query: ({ url, noDisplay }) => {
        return {
          url: `users/employee-calculate-increment${url ? url : ""}`,
          method: "POST",
          msz: noDisplay ? false : true,
        };
      },
    }),

    GetIncrement: builder.query({
      query: ({ url, noDisplay }) => {
        return {
          url: `users/employee-salary-increment${url ? url : ""}`,
          msz: noDisplay ? false : true,
        };
      },
      transformResponse: (response, meta, arg) => response?.data,
    }),

    MutateIncrement: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/employee-salary-increment${url ? url : ""}`,
          method: method,
          body: body,
          msz: true,
        };
      },
    }),

    // Arrear
    GetArrearTypes: builder.query({
      query: () => {
        return {
          url: `users/salary-arrear-type`,
        };
      },
    }),
    GetArrearHeads: builder.query({
      query: () => {
        return {
          url: `users/salary-arrear-heads`,
        };
      },
    }),
    GetArrearList: builder.query({
      query: ({ url }) => {
        return {
          url: `users/salary-arrear-list${url ? url : ""}`,
        };
      },
    }),
    MutateArrear: builder.mutation({
      query: ({ method, body }) => {
        return {
          url: `users/salary-arrear`,
          method: method,
          body: body,
          msz: true,
        };
      },
    }),
    GetEmployeeListArrear: builder.query({
      query: ({ url }) => {
        return {
          url: `users/salary-arrear-filter${url ? url : ""}`,
        };
      },
    }),
    CalculateArrear: builder.mutation({
      query: ({ method, body }) => {
        return {
          url: `users/salary-arrear-calculate`,
          method: method,
          body: body,
          msz: true,
        };
      },
    }),

    //Payment Info
    ViewPaymentInfo: builder.query({
      query: ({ url }) => {
        return {
          url: `users/salary-payment-info${url ? url : ""}`,
        };
      },
    }),
    GetPaymentInfo: builder.query({
      query: ({ url }) => {
        return {
          url: `users/employee-salary-payment-info${url ? url : ""}`,
        };
      },
    }),
    AddPaymentInfo: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/salary-payment-info${url ? url : ""}`,
          method: method,
          body: body,
          msz: true,
        };
      },
    }),

    EmployeeSalaryHistory: builder.query({
      query: () => {
        return {
          url: `users/salary-slip-history`,
        };
      },
    }),

    EmployeeIncrementHistory: builder.query({
      query: () => {
        return {
          url: `users/employee-salary-increment-history`,
        };
      },
    }),

    EmployeeArrearHistory: builder.query({
      query: () => {
        return {
          url: `users/employee-salary-arrear`,
        };
      },
    }),
    GetUserIPReport: builder.query({
      query: () => {
        return {
          url: `users/user-ipr-sheet`,
        };
      },
    }),
    GetSalaryDetails: builder.query({
      query: (month) => {
        const queryParams = month?.map((item) => `monthUids=${item}`).join("&");

        return {
          url: `users/payroll-dashboard-data?${queryParams}`,
        };
      },
    }),
    GetDueSalaryDetails: builder.query({
      query: (month) => {
        const queryParams = month?.map((item) => `monthUids=${item}`).join("&");
        return {
          url: `users/payroll-projected-dashboard-data?${queryParams}`,
        };
      },
    }),
    GetCTCName: builder.query({
      query: () => {
        return {
          url: `users/ctc-name/priority/true`,
        };
      },
      providesTags: ["ctc-name"],
    }),
    ManageCTCName: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/ctc-name${url ? url : ""}`,
          method: method,
          body: body,
          msz: true,
        };
      },
      invalidatesTags: ["ctc-name"],
    }),
    GetCTCStructure: builder.query({
      query: () => {
        return {
          url: `users/ctc-structure`,
        };
      },
      providesTags: ["ctc-structure"],
    }),
    ManageCTCStructure: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/ctc-structure${url || ""}`,
          method: method,
          body: body,
          msz: true,
        };
      },
      invalidatesTags: ["ctc-structure"],
    }),
    ManageStructureEmployee: builder.mutation({
      query: ({ url, method, body }) => {
        return {
          url: `users/employee-payroll-basic${url || ""}`,
          method: "post",
          body: body,
        };
      },
    }),
    AdminEmployeeListGetOperation: builder.mutation({
      query: (body) => {
        return {
          url: `users/payroll-employee-info`,
          method: "POST",
          body: body,
        };
      },
      transformResponse: (res) => res?.data ?? [],
      providesTags: ["employee-info-user"],
    }),
    EmployeeEmailVerification: builder.mutation({
      query: ({ email, userUid }) => {
        return {
          url: `users/employee-otp?email=${email}&userUid=${userUid}`,
          method: "PUT",
          msz: false,
        };
      },
    }),
    EmployeeGSTVerification: builder.mutation({
      query: ({ body }) => {
        return {
          url: `users/verify-gst`,
          method: "POST",
          body: body,
        };
      },
    }),
    EmployeePANVerification: builder.mutation({
      query: ({ body }) => {
        return {
          url: `users/verify-pan`,
          method: "POST",
          body: body,
        };
      },
    }),
    AdminValidateOtp: builder.mutation({
      query: ({ email, otp, userUid }) => {
        return {
          url: `users/admin-email-validate?email=${email}&otp=${otp}&userUid=${userUid}`,
          method: "PUT",
          msz: false,
        };
      },
    }),
    EmployeeValidateOtp: builder.mutation({
      query: ({ email, otp, userUid }) => {
        return {
          url: `users/employee-validate-otp?email=${email}&otp=${otp}&userUid=${userUid}`,
          method: "PUT",
          msz: false,
        };
      },
    }),
    EmployeeImageUpload: builder.mutation({
      query: ({ body, uid }) => {
        return {
          url: `users/employee-profile/${uid}`,
          method: "PUT",
          body: body,
          msz: false,
        };
      },
    }),
  }),
});

export const {
  //Allowances
  useAllowanceQuery,
  useAllowanceOperationMutation,
  useAllowanceStructureQuery,
  useAllowanceStructureOperationMutation,

  //Deductions
  useDeductionQuery,
  useDeductionOperationMutation,
  useDeductionsStructureQuery,
  useDeductionsStructureOperationMutation,

  //Remittances
  useRemittancesQuery,
  useRemittancesOperationMutation,
  useRemittanceStructureQuery,
  useRemittanceStructureOperationMutation,

  //Payscale
  usePayScaleQuery,
  usePayScaleOperationMutation,

  //Increment Cycle
  useGetIncrementCycleQuery,
  useIncrementCycleOperationMutation,

  //Designation Structure
  useDesignationStructureQuery,
  useDesignationStructureOperationMutation,

  //Employee Info
  useEmployeeInfoQuery,
  useEmployeeInfoFilterQuery,
  useLazyEmployeeInfoFilterQuery,
  useExcelImportQuery,
  useEmployeeExcelImportQuery,
  useEmployeeInfoOperationMutation,
  useGetPayrollStaticDataQuery,
  useLazyGetPayrollStaticDataQuery,
  useGetContractingCompanyQuery,
  useMutateContractingCompanyMutation,
  useEmployeePayrollSetValuesMutation,

  //FWM
  useEmployeeModificationListQuery,
  useEmployeeFilterQuery,
  useEmployeeModifyMutation,
  useGetFieldWiseListQuery,
  useFwmExcelImportMutation,

  //Hourly Paid
  useGetHourlyPaidEmployeeQuery,
  useLazyGetHourlyPaidEmployeeQuery,
  useMutateHourlyPaidEmployeeMutation,

  //Salary Generation
  useGetAllEmployeeForSalaryQuery,
  useLazyGetAllEmployeeForSalaryQuery,
  useSalaryGenerationOperationMutation,
  useGetGeneratedSalaryQuery,
  useLazyGetGeneratedSalaryQuery,
  useGetDesignationADRMutation,
  useGetUserIPReportQuery,

  //Leave Encashment
  useGetLeaveEncashmentQuery,
  useLeaveEncashmentEmployeeInfoOperationMutation,
  useLeaveEncashmentOperationMutation,
  useLeaveEncashmentDeleteOperationMutation,

  //Salary Months
  useGetSalaryMonthsQuery,
  useGetSalaryGeneratedMonthsQuery,
  useGetSalaryDueMonthsQuery,
  useMutateSalaryMonthsMutation,
  useGetSalaryMonthsListQuery,

  //Projected Salary
  useGetProjectedSalaryQuery,
  useMutateProjectedSalaryMutation,
  useGetProjectedSalaryFilterQuery,
  useLazyGetProjectedSalaryFilterQuery,

  //Recalculate Salary
  useMutateRecalculateSalaryMutation,

  //Increment
  useGetSalaryIncrementTypesQuery,
  useCalculatIncrementMutation,
  useMutateIncrementMutation,
  useGetIncrementQuery,
  useLazyGetIncrementQuery,

  //Arrear APIs
  useGetArrearTypesQuery,
  useGetArrearHeadsQuery,
  useGetArrearListQuery,
  useMutateArrearMutation,
  useGetEmployeeListArrearQuery,
  useLazyGetEmployeeListArrearQuery,
  useCalculateArrearMutation,

  //Payment Info
  useViewPaymentInfoQuery,
  useLazyViewPaymentInfoQuery,
  useGetPaymentInfoQuery,
  useLazyGetPaymentInfoQuery,
  useAddPaymentInfoMutation,

  //Reports
  useGetEmployeeDetailsQuery,
  useLazyGetEmployeeDetailsQuery,
  useGetSalarySlipQuery,
  useGetSalaryBillQuery,
  useSalaryBillPOSTMutation,
  useSalarySlipPOSTMutation,
  useIPRPOSTMutation,
  useLWPPOSTMutation,
  usePFContributionPOSTMutation,
  useJoiningDetailsPOSTMutation,
  useLeftDetailsPOSTMutation,
  useGetSalaryCertificateMutation,
  useGetSalaryCertificateUserQuery,
  useGetDepartmentWiseSalaryQuery,
  useGetPFDetailsUserQuery,

  usePFAbstractGetQuery,
  usePFSubscribePOSTMutation,

  useGPLEPReportMutation,
  useGetBankReportQuery,
  useArrearBankReportQuery,
  useEmployeeSalaryHistoryQuery,
  useEmployeeIncrementHistoryQuery,
  useEmployeeArrearHistoryQuery,
  useAdminFeeInstallmentGetQuery,
  useGetSalaryDetailsQuery,
  useGetDueSalaryDetailsQuery,

  //ctc
  useGetCTCNameQuery,
  useManageCTCNameMutation,
  useGetCTCStructureQuery,
  useManageCTCStructureMutation,

  useManageStructureEmployeeMutation,
  useAdminEmployeeListGetOperationMutation,
  useEmployeeEmailVerificationMutation,
  useEmployeeGSTVerificationMutation,
  useEmployeePANVerificationMutation,
  useEmployeeValidateOtpMutation,
  useAdminValidateOtpMutation,
  useEmployeeImageUploadMutation,
} = PayrollSlice;
